import { API_BASE_URL } from "../config";
export const BASE_URL = `https://studentapi.staging.vidyanet.co`;
// export const BASE_URL = `${API_BASE_URL}`;

//OTP API
const OTP = `/auth/otp`;
export const GENERATE_OTP = `${OTP}/gentrator`;
export const VALIDATE_OTP = `${OTP}/validator`;

//User
export const CREATE_USER = `/users/student`;

//AUTH
export const LOGIN = `/login`;
export const LOGOUT = `/logout`;

//User
export const GENERATE_USER = `/user/student`;
export const GET_USER = `/user`; //To  get all users
export const GET_USER_BY_ID = `/user`; //To get user by id

//Teachers
export const REGISTER_TEACHER = `/teacher/register-teacher`;
export const GET_TEACHER = `/teacher/teachers`; //To  get all teachers

//Batches
export const GET_BATCHES_BY_STUDENT = `/batches/student-batches`; //To  get all batches
export const GET_BATCHES_BY_COACHING = `/batches/coaching-batches`; //To  get all batches
export const GET_BATCHES_FEESTRUCTURE = `/batches/feestructure`; //To  get all batches

//Classes
export const CREATE_SCHEDULE_CLASS = `/classes/create-schedule-class`; //To  get all classes
export const GET_UPCOMING_CLASSES = `/classes/upcoming`; //To  get all upcoming classes
export const GET_RECORDINGS = `/classes/recordings`; //To  get all recordings
export const GET_COURSE_RECOMMENDATION = `/course/recommendation`; //To  get all recordings

//Attendance
export const MARK_ATTENDANCE = `/attendance/mark-attendance`; //To  get all attendance
export const GET_ATTENDANCE_BY_COACHING = `/attendance/attendance/coaching-wise`;
export const GET_CURRENT_CLASS_ATTENDANCE = `/attendance/current-class`;

//Assignments
export const CREATE_ASSIGNMENT = `/assignments/create-schedule-assignment`;
export const GET_UPCOMING_ASSIGNMENTS = `/assignments/upcoming`; //To  get all assignments
export const GET_SUBMITTED_ASSIGNMENTS = `/assignments/submitted`; //To  get all pending assignments

//Notes
export const CREATE_NOTE = `/notes/create-note`;
export const GET_NOTES = `/notes/get`;

//Report
export const REPORT_ISSUE = `/student-report/create`;

//Notifications
export const GET_NOTIFICATIONS = `/notification/student`;
export const MARK_NOTIFICATIONS = `/notification/notifications/mark-read`;

//Payment
export const GET_PAYMENTS = `/payments/students`;

//Nearby Educentre
export const GET_NEARBY = `/search/global`;
